module.exports = __webpack_public_path__ + "img/20.6ec2fcb1.jpg";